import axios from 'axios';
import { useQuery } from 'react-query';
import { getLease } from 'services/leaseService';

export function useFetchLease({ organizationId, propertyId, leaseId }) {
  const source = axios.CancelToken.source();
  const { token } = source;
  const options = { cancelToken: token };

  return useQuery(
    [leaseId],
    () => getLease(organizationId, propertyId, leaseId, options),
    {
      enabled: !!leaseId,
      staleTime: 60000,
    },
  );
}
